import ComingSoon from '@/components/ComingSoon';

const Services = () => {
    return (
        <ComingSoon />
    );
};

export default Services;
